/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
// import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VALIDATE_REFERAL_COUPON } from "../graphql";
import { VApplication } from "../../../application";
// import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";
import config from "../config/useremail.config.json";
import { GetOpenReg } from "../graphql";
import { StorageModule } from "@vlinder-web/storage-module-react";
const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ValidateReferralProps {
  code?: any;
  // presentation: any;
  // section?: any;
  // type?: any;
  // email?: any;
  // presentation?: any;
  // sectionOptType?: any;
  // email?: any;
  // partition?: any;
  // inviteType?: any;
}
export interface IValidateReferalMethods extends IPluginMethodMap {
  validateReferral(args: any): Promise<any>;
}

export class ValidateReferralService implements IAgentPlugin {
  readonly methods: IValidateReferalMethods;

  constructor() {
    this.methods = {
      validateReferral: this.validateReferral.bind(this),
    };
  }

  async validateReferral(args: ValidateReferralProps) {
    console.log("in send purchase=====>",args);
    const graphqlModule = getGraphQLModule();
    const storageSrv = StorageModule.getInstance();

    const client = graphqlModule.getClient("graphql-gateway");
    // const sendInvite = this.createInviteObjects(args);
    const { code } = args;
    

    // console.log(
    //   "validateReferral----->",
    //   email,
    //   partition,
    //   sectionOptType,
    //   inviteType
    // );
    try {
      if (client) {
        const id = await client.query({
          query: GetOpenReg,
          variables: {},
          fetchPolicy: "network-only",
        });
        const presentationId = storageSrv.get("presentationId");
        if (id?.data) {
          console.log(id?.data);
          const res = await client.mutate({
            mutation: VALIDATE_REFERAL_COUPON,
            variables: {
              filter: {
                couponCode: code,
                couponType: "Referral",
                presentation: presentationId,
              },
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.validateReferralCoupon) {
            return {
              ...res?.data?.validateReferral,
            };
          }
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
}
